import { LayerBreadcrumb } from '@/components/editor/hud/LayerBreadcrumb';
import { CanvasScaleControls } from './CanvasScaleControls';
import { BackToSearchPill } from '@/components/search/BackToSearchPill';

export interface CanvasHeaderProps {
  breadcrumbs: Array<{ id: string | null; name: string }>;
  onNavigateToLevel: (index: number) => void;
  contentScale: number;
  minScale: number;
  maxScale: number;
  onScaleUp: () => void;
  onScaleDown: () => void;
  onResetScale: () => void;
  onFitToScreen?: () => void;
  zoomMode?: 'static' | 'dynamic';
  /**
   * Used by /preview which renders its own floating zoom-panel.
   * Hide the inbuilt scale-controls but keep breadcrumbs (layer-drilldown
   * navigation is still useful in read-only preview).
   */
  hideScaleControls?: boolean;
}

/**
 * Sticky header that sits on top of WorkflowCanvas:
 * layer breadcrumb on the left, zoom controls on the right.
 */
export function CanvasHeader(props: CanvasHeaderProps) {
  return (
    <div className="sticky top-4 left-0 right-0 z-20 flex justify-between items-start px-4 pointer-events-none">
      <div className="flex-shrink-0 flex items-center gap-2 pointer-events-auto">
        <LayerBreadcrumb breadcrumbs={props.breadcrumbs} onNavigate={props.onNavigateToLevel} />
        <BackToSearchPill />
      </div>
      {!props.hideScaleControls && (
        <CanvasScaleControls
          contentScale={props.contentScale}
          minScale={props.minScale}
          maxScale={props.maxScale}
          onScaleUp={props.onScaleUp}
          onScaleDown={props.onScaleDown}
          onResetScale={props.onResetScale}
          onFitToScreen={props.onFitToScreen}
          zoomMode={props.zoomMode}
        />
      )}
    </div>
  );
}
